import { observer } from 'mobx-react';
import {
  Table,
  TableBody,
  Paper,
  TableCell,
  TableContainer,
  TableRow,
  Box,
  Grid,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  paper: {
    marginBottom: theme.spacing(2),
  },
  row: {
    '&:last-child td': {
      borderBottom: 0,
    }
  },
  container: {
    paddingLeft: '0',
    paddingRight: '0'
  }
}));

interface SubStatusTableProps {
  counts: { subStatus: string; count: number }[];
  columns?: number;
  title?: string;
}

export const SubStatusTable = observer(({ counts, columns = 3, title = 'Loan Volume by Sub-Status' }: SubStatusTableProps) => {
  const classes = useStyles();
  if (!counts?.length) return null;

  const rows: { subStatus: string; count: number }[][] = [];
  for (let i = 0; i < counts.length; i += columns) {
    rows.push(counts.slice(i, i + columns));
  }
  return (
    <Paper className={classes.paper}>
      <Box pl={4} pr={4} pt={1} pb={3}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h5">{title}</Typography>
          </Grid>
          <TableContainer>
            <Table>
              <TableBody>
                {rows.map((rowItems, rowIndex) => (
                  <TableRow key={rowIndex} className={classes.row}>
                    {rowItems.map(({ subStatus, count }) => (
                      <TableCell key={subStatus}>
                        {subStatus.split('_').join(' ')}: {count}
                      </TableCell>
                    ))}
                    {rowItems.length < columns &&
                      Array.from({ length: columns - rowItems.length }).map((_, idx) => (
                        <TableCell key={`empty-${idx}`} />
                      ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Box>
    </Paper>
  );
});